import { REFUND_SUCCESS_ADD, REFUND_SUCCESS_EDIT, BANK_LIST_RESULT, LIST_USER_REFUNDS, ITEM_SELECTED_FOR_EDIT_REFUND } from "./actionTypes";
import { alertMessenger } from "./alertAction";
import CommonAxios from '../../axios/AxiosCommon';
import Refundaxios from '../../axios/Customer';

export const RefundSuccessAdd = (data = false) => {
    return {
        type: REFUND_SUCCESS_ADD,
        ResultOfAddRefund: data
    }
}

export const RequestForAddRefund = (data) => {
    return dispatch => {
        Refundaxios({
            method: 'post',
            url: '/AddRefund',
            data: {
                PassengersHeaderFullName: data.PassengersHeaderFullName,
                PNR: data.PNR,
                Watcher: data.Watcher,
                RefundReasonId: data.RefundReasonId,
                FullName: data.FullName,
                IBAN: data.IBAN,
                AccountNumber: data.AccountNumber,
                CardNumber: data.CardNumber,
                BankId: data.BankId,
                Description: data.Description,
                Id: data.Id,
                RequestedNumber: localStorage["CELL_PHONE"]
            }
        })
            .then(response => {
                dispatch(RefundSuccessAdd(true))
                dispatch(alertMessenger(response.data.Message))
                dispatch(RequestForRefundList())
            })
            .catch(error => {
                dispatch(alertMessenger(error.response.data.Message))
                dispatch(RefundSuccessAdd(false))
            })
            .catch(() => {
                dispatch(alertMessenger("خطا در ارتباط با شبکه"))
            })
    }
}

export const RefundSuccessEdit = (data = false) => {
    return {
        type: REFUND_SUCCESS_EDIT,
        ResultOfEditRefund: data
    }
}

export const RequestForEditRefund = (data) => {
    return dispatch => {
        Refundaxios({
            method: 'post',
            url: '/EditRefund',
            data: {
                PassengersHeaderFullName: data.PassengersHeaderFullName,
                PNR: data.PNR,
                Watcher: data.Watcher,
                RefundReasonId: data.RefundReasonId,
                FullName: data.FullName,
                IBAN: data.IBAN,
                AccountNumber: data.AccountNumber,
                CardNumber: data.CardNumber,
                BankId: data.BankId,
                Description: data.Description,
                Id: data.Id,
                RequestedNumber: localStorage["CELL_PHONE"]
            }
        })
            .then(response => {
                dispatch(RefundSuccessEdit(true))
                dispatch(alertMessenger(response.data.Message))
                dispatch(RequestForRefundList())
            })
            .catch(error => {
                dispatch(alertMessenger(error.response.data.Message))
                dispatch(RefundSuccessEdit(false))
            })
            .catch(() => {
                dispatch(alertMessenger("خطا در ارتباط با شبکه"))
            })
    }
}

export const BankListResult = (list) => {
    return {
        type: BANK_LIST_RESULT,
        BanklIst: list
    }
}

export const RequestForBankName = () => {
    return dispatch => {
        CommonAxios({
            method: 'get',
            url: '/GetBank',
        })
            .then(response => {
                response.data.Result.unshift(
                    {
                        BankName: null,
                        Id: 0,
                    }
                )
                dispatch(BankListResult(response.data.Result))
            })
            .catch(error => {
                dispatch(alertMessenger(error.response.data.Message))
            })
            .catch(() => {
                dispatch(alertMessenger("خطا در ارتباط با شبکه"))
            })
    }
}

export const listUserRefunds = (data) => {
    return {
        type: LIST_USER_REFUNDS,
        refundList: data
    }
}

export const RequestForRefundList = (page = 0, Sort = true, status = -1, pagesize = 10) => {
    return dispatch => {
        dispatch(listUserRefunds(null))
        Refundaxios({
            method: 'get',
            url: '/GetUserRefundsByStatus',
            params: {
                "pagesize": pagesize,
                "pageindex": page,
                "orderby": "id",
                "RequestedNumber": localStorage["LOG_IN_WITH_PHONE"] ? localStorage["CELL_PHONE"] : "",
                "order": Sort === true ? "desc" : "asc",
                "StatusID": status
            }
        })
            .then(response => {
                dispatch(listUserRefunds(response.data.Result))
            })
            .catch(error => {
                dispatch(alertMessenger(error.response.data.Message))
            })
            .catch(() => {
                dispatch(alertMessenger("خطا در ارتباط با شبکه"))
            })
    }
}

export const ItemSelectedForEditRefund = (value = null) => {
    return {
        type: ITEM_SELECTED_FOR_EDIT_REFUND,
        selecteValue: value
    }
}
